import React, { useEffect, useState } from "react";
import ImageTag from "../reusebale/imageTag";
import ParagraphTag from "../reusebale/Paragraph";
import db from "../../db/index.json";
import { Search } from "lucide-react";
import BaseUrl from "../../constants/BaseUrl";
import { useSelector, useDispatch } from "react-redux";
import * as DataAction from "../../store/actions/data/DataAction";
import NoChat from "../reusebale/noChat";
import { motion } from "framer-motion";
import socket from "../../config/socketIoConfig";
import {
  GetAllActiveChatsActionConst,
  GetAllCompletedChatSessionsActionConst,
} from "../../store/constants/DataActionConst";

const ChatName = () => {
  const [activeTab, setActiveTab] = useState("all");
  const { chat } = db;

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );

  const {
    allActiveChatSessions,
    selectedSessionId,
    currentShift,
    allCompletedChatSessions,
    selectedCompletedSessionId,
  } = useSelector((state) => state.data);

  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchChatSessions = () => {
      if (
        currentShift?._id &&
        loginSuccess &&
        loginSuccess.user.type === "community"
      ) {
        dispatch(
          DataAction.GetAllActiveChatSessions(currentShift?._id, loginSuccess)
        );
        dispatch(
          DataAction.GetAllCompletedChatSessionsAction(
            currentShift?._id,
            loginSuccess
          )
        );
      } else {
        dispatch(
          DataAction.GetAllActiveChatSessionsTechnical(
            currentShift?._id,
            loginSuccess
          )
        );
        dispatch(
          DataAction.GetAllTechnicalCompletedChatSessionsAction(
            currentShift?._id,
            loginSuccess
          )
        );
      }

      // alert(currentShift?._id)
    };

    fetchChatSessions();
  }, [currentShift, activeTab, dispatch, loginSuccess]);

  useEffect(() => {
    if (!loginSuccess?.user?._id) return;

    const userId = loginSuccess.user._id;

    const handleConnect = () => {
      console.log("✅ Connected to socket");
      socket.emit("joinRoom", userId);
      console.log("📨 Emitted joinRoom for user:", userId);
    };

    const handleMessage = (messageObj) => {
      // Check if we received an empty array (indicating chat completion)
      if (Array.isArray(messageObj) && messageObj.length === 0) {
        // Refresh active chat sessions based on user type
        if (loginSuccess?.user?.type === "community") {
          dispatch(
            DataAction.GetAllActiveChatSessions(currentShift?._id, loginSuccess)
          );
        } else if (loginSuccess?.user?.type === "technical") {
          dispatch(
            DataAction.GetAllActiveChatSessionsTechnical(
              currentShift?._id,
              loginSuccess
            )
          );
        }
        return;
      }

      // Check if the message object has conversation data
      const hasValidConversation =
        messageObj?.conversation &&
        Array.isArray(messageObj.conversation) &&
        messageObj.conversation.length > 0;

      if (messageObj && hasValidConversation) {
        // Update the Redux state with the received message
        dispatch({
          type: GetAllActiveChatsActionConst.UPDATE_ACTIVE_CHAT_SESSION,
          data: messageObj,
        });

        // Automatically select this chat session to open the conversation
        if (messageObj._id) {
          dispatch(DataAction.selectedSessionIdAction(messageObj._id));
          // Clear any selected completed session since we're selecting an active one
          dispatch(DataAction.SelectedComplatedSessionIdAction(null));
          // Switch to "all" tab if we're on completed tab
          if (activeTab === "completed") {
            setActiveTab("all");
          }
        }
      } else {
        // Invalid message received - no conversation data
      }
    };

    if (socket.connected) {
      handleConnect();
    } else {
      socket.on("connect", handleConnect);
    }

    socket.on("chat:receive", handleMessage);

    return () => {
      socket.off("chat:receive", handleMessage);
      socket.off("connect", handleConnect);
    };
  }, [loginSuccess, activeTab, dispatch, currentShift?._id]);

  useEffect(() => {
    if (activeTab === "all" && allActiveChatSessions.length) {
      dispatch(
        DataAction.selectedSessionIdAction(allActiveChatSessions?.[0]?._id)
      );
    }
  }, [activeTab, allActiveChatSessions, dispatch]);

  function GetLastMessageTimeDifference(conversation, customerData) {
    if (!conversation || conversation.length === 0)
      return "No conversation found";

    const customerId = customerData._id;

    const customerMessages = conversation.filter(
      (msg) => msg.id === customerId
    );

    if (customerMessages.length === 0) return "No messages from this customer";

    const lastMessage = customerMessages[customerMessages.length - 1];

    const lastMessageTime = new Date(lastMessage.dateTime);
    const currentTime = new Date();

    const timeDifferenceMs = currentTime - lastMessageTime;

    const timeDifferenceMin = Math.floor(timeDifferenceMs / 60000);

    return `${timeDifferenceMin} min ago`;
  }

  function GetLastMessage(conversation) {
    if (!conversation || conversation.length === 0) return "No messages found";

    // Get the last object from the array
    const lastMessageObject = conversation[conversation.length - 1];

    // Return the message property
    return lastMessageObject.message;
  }

  function capitalizeFirstLetter(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <div className="bg-[#0381CA]/5 rounded-2xl w-full flex flex-col items-center pt-3 h-full">
      {/* Logo */}
      <motion.div
        className="h-[25%] w-full flex flex-col items-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        {/* Tab headers */}
        <div className="flex justify-between rounded-2xl bg-gray-50 w-[90%] mt-3">
          <button
            onClick={() => {
              setSearch("");
              dispatch(DataAction.SelectedComplatedSessionIdAction(null));
              setActiveTab("all");
            }}
            className={`py-2 w-[49%] font-popinsMedium text-sm ${
              activeTab === "all"
                ? "text-white bg-themeColor rounded-2xl mx-1 my-1"
                : "text-darkColor/40"
            }`}
          >
            All
          </button>
          <button
            onClick={() => {
              setSearch("");
              dispatch(DataAction.selectedSessionIdAction(null));
              setActiveTab("completed");
            }}
            className={`py-2 w-[49%] font-popinsMedium text-sm ${
              activeTab === "completed"
                ? "text-white bg-themeColor rounded-2xl mx-1 my-1"
                : "text-darkColor/40"
            }`}
          >
            Completed
          </button>
        </div>
        <motion.div
          className="relative w-[90%] mx-auto mt-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="text"
            placeholder="Search"
            className="w-full font-popinsRegular bg-gray-100 pl-10 py-3 text-sm rounded-full text-darkColor placeholder:text-zinc-700/50"
          />
          <div className="absolute top-[14px] left-4">
            <Search color="#1A1A1A5D" size={15} />
          </div>
        </motion.div>
      </motion.div>

      {/* Tab content */}
      <div className="w-[90%] h-[74%] overflow-x-scroll mx-auto panelScroll">
        {activeTab === "all" &&
          (allActiveChatSessions.length > 0 ? (
            allActiveChatSessions.map((item, index) => {
              const Name = `${item?.customerData?.firstName} ${item?.customerData?.lastName}`;
              if (
                String(Name).trim().toUpperCase().includes(search.toUpperCase())
              ) {
                return (
                  <motion.div
                    key={index}
                    onClick={() =>
                      dispatch(DataAction.selectedSessionIdAction(item._id))
                    }
                    className={`flex justify-between cursor-pointer p-1 hover:bg-dangerColor/20 rounded-lg ${
                      selectedSessionId === item._id ? "bg-white" : ""
                    }`}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <div className="flex items-center justify-between w-[75%]">
                      <div className="w-[20%] rounded-full">
                        <ImageTag
                          path={
                            item?.customerData?.profileImage?.url ||
                            "/assets/daashboard/profile-complete/user-icon.png"
                          }
                          classes="w-full rounded-full"
                          altText="logo"
                        />
                      </div>
                      <div className="w-[78%] cursor-pointer">
                        <ParagraphTag
                          content={`${item?.customerData?.firstName} ${item?.customerData?.lastName}`}
                          classes="text-black font-popinsSemiBold text-sm"
                        />
                        <ParagraphTag
                          content={GetLastMessage(item?.conversation)}
                          classes={`${
                            item.active ? "text-black" : "text-black/60"
                          } font-popinsMedium text-xs line-clamp-1`}
                        />
                      </div>
                    </div>
                    <div className="w-[25%] flex flex-col items-end justify-between text-end py-3">
                      <ParagraphTag
                        content={GetLastMessageTimeDifference(
                          item?.conversation,
                          item?.customerData
                        )}
                        classes="text-black/90 font-popinsMedium text-[10px]"
                      />

                      <ParagraphTag
                        content={capitalizeFirstLetter(
                          item?.customerData?.role
                        )}
                        classes="text-black/90 font-popinsMedium font-bold text-[8px] text-themeColor"
                      />

                      {item.active && (
                        <div className="size-2 rounded-full bg-green-500"></div>
                      )}
                    </div>
                  </motion.div>
                );
              }
              return null;
            })
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              <NoChat />
            </motion.div>
          ))}

        {activeTab === "completed" &&
          (allCompletedChatSessions.length > 0 ? (
            allCompletedChatSessions.map((item, index) => {
              const Name = `${item?.customerData?.firstName} ${item?.customerData?.lastName}`;
              if (
                String(Name).trim().toUpperCase().includes(search.toUpperCase())
              ) {
                return (
                  <motion.div
                    key={index}
                    onClick={() =>
                      dispatch(
                        DataAction.SelectedComplatedSessionIdAction(item._id)
                      )
                    }
                    className={`flex justify-between cursor-pointer p-1 hover:bg-dangerColor/20 rounded-lg ${
                      selectedCompletedSessionId === item._id ? "bg-white" : ""
                    }`}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <div className="flex items-center justify-between w-[75%]">
                      <div className="w-[20%] rounded-full">
                        <ImageTag
                          path={
                            item?.customerData?.profileImage?.url ||
                            "/assets/daashboard/profile-complete/user-icon.png"
                          }
                          classes="w-full rounded-full"
                          altText="logo"
                        />
                      </div>
                      <div className="w-[78%] cursor-pointer">
                        <ParagraphTag
                          content={`${item?.customerData?.firstName} ${item?.customerData?.lastName}`}
                          classes="text-black font-popinsSemiBold text-sm"
                        />
                        <ParagraphTag
                          content={GetLastMessage(item?.conversation)}
                          classes={`${
                            item.active ? "text-black" : "text-black/60"
                          } font-popinsMedium text-xs line-clamp-1`}
                        />
                      </div>
                    </div>
                    <div className="w-[25%] flex flex-col items-end justify-between text-end py-3">
                      <ParagraphTag
                        content={GetLastMessageTimeDifference(
                          item?.conversation,
                          item?.customerData
                        )}
                        classes="text-black/90 font-popinsMedium text-[10px]"
                      />
                      <ParagraphTag
                        content={capitalizeFirstLetter(
                          item?.customerData?.role
                        )}
                        classes="text-black/90 font-popinsMedium font-bold text-[8px] text-themeColor"
                      />
                      {item.active && (
                        <div className="size-2 rounded-full bg-green-500"></div>
                      )}
                    </div>
                  </motion.div>
                );
              }
              return null;
            })
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              <NoChat />
            </motion.div>
          ))}
      </div>
    </div>
  );
};

export default ChatName;
